//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Account',
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        account: '',
        password: '',
      },
      // 表单验证对象
      rules: {
        account: [
          {
            required: true,
            message: '请输入员工账号',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入员工密码',
            trigger: 'blur',
          },
        ],
      },
      loading: false,
    };
  },
  computed: {
    loginValid() {
      return this.formData.account && this.formData.password;
    },
  },
  methods: {
    async login() {
      if (this.loading) return;
      this.loading = true;
      await this.$request({
        url: this.$api.login,
        data: {
          account: this.formData.account,
          password: this.formData.password,
          login_type: 'admin',
        },
        client: {
          product: Number(this.product),
        },
      })
        .then((res) => {
          console.log('账号密码登录返回值', res);
          this.loginSuccess(res);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    loginSuccess(data) {
      this.$message({
        message: '登录成功',
        type: 'success',
      });
      /*
      this.$cookies.set('uin', data.uin);
      this.$cookies.set('saas_token', data.token);
      */
      // 登录成功后，重定向去客户的域名
      setTimeout(() => {
        if (this.redirectUrl) {
          window.location.href = `${decodeURIComponent(
            this.redirectUrl,
          )}?token=${encodeURIComponent(data.token)}&uin=${data.uin}&expires_in=${data.expires_in}`;
        }
      }, 500);
    },
  },
};
